import { Injectable } from '@angular/core';
import { ICollection } from '@sv/interfaces';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CollectionService {
  notLoaded: ICollection = {
    overline: 'Willkommen',
    headline: 'in der Akademie Übersicht',
    text: 'Die Kacheln zeigen Ihnen die einzelnen Themen. Durch klicken gelangen Sie zu den einzelnen Kursen.',
    searchText: 'Themen durchsuchen',
    captionEnter: 'AUSWÄHLEN',
    rooms: []
  };

  collectionListener = new BehaviorSubject<ICollection>(this.notLoaded);

  getCollectionListener() {
    return this.collectionListener.asObservable();
  }

  async setCollection(collectionId: string | ICollection) {
    if (typeof collectionId !== 'string') {
      this.collectionListener.next(collectionId);
    }
  }

  /*   async getTradeFairById(tradeFairId: string): Promise<ICollection> {
    const result = await this.http
      .get<{ status: string; data: ICollection; error? }>(customApp.url + `/app/event/tradeFair/findById?id=${tradeFairId}`)
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      return result.data;
    }
  }
  async getTradeFairWithBooths(tradeFairId: string): Promise<ICollection> {
    const result = await this.http
      .get<{ status: string; data: ICollection; error? }>(customApp.url + `/app/event/tradeFair/allBooths?id=${tradeFairId}`)
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      return result.data;
    }
  } */
}
